import { RequestHelper } from "../Helpers/RequestHelper.js";
import { DataDriver } from "../Drivers/DataDriver.js";

export class OfferlogixDriver extends DataDriver {
    constructor(pmdrs) {
        super(pmdrs);
        this.key = DataDriver.OFFERLOGIX_KEY;
        this.themeClass = "pm-drs-offerlogix-theme";
    }

    pullApiConfig(successCallback, errorCallback) {
        let driver = this;
        let pmdrs = this.pmdrs;
        //SUCCESS
        let sc = (response) => {
            if (response) {
                driver.apr = JSON.parse(response);
            }
            if (successCallback) {
                successCallback();
            }
        };

        //ERROR
        let ec = () => {
            console.log("Error getting OfferlogixDriver config");
            if (errorCallback) {
                errorCallback();
            }
        };

        //get APR from pm-drs-api
        pmdrs.pmApi.getOfferlogixAPR(
            pmdrs.config.accountId,
            pmdrs.frontApp.config.vehicle.vin || "default",
            pmdrs.config.offerLogixSource,
            sc,
            ec
        );
    }

    /**
     * [getMonthlyPayment description]
     * @param  {Boolean} taxes to get taxes or not
     * @param  {string} type            lease of finance
     * @param  {object} paymentData     [description]
     * @param  {function} successCallback
     * @param  {function} errorCallback
     * @return void
     */
    getPayment(taxes, type, paymentData, successCallback, errorCallback) {
        let sc = (response) => {
            response = JSON.parse(response);
            let paymentObject = response.payments[0];
            successCallback(paymentObject);
        };
        let pmdrs = this.pmdrs;
        let vehicle = pmdrs.frontApp.config.vehicle;
        let requestParams = {
            Source: pmdrs.config.offerLogixSource,
            VIN: vehicle.vin,
            "vehicle.transactionType": type == "lease" ? "Lease" : "Purchase", //all, purchase and lease
        };
        //REQUEST TO LOCAL DB IN PM ORE API
        if (paymentData.local) {
            requestParams.local = true;
            pmdrs.pmApi.getOfferlogixPayments(requestParams, sc, errorCallback);
            return;
        }

        //get Payment Offer from pm-drs-api
        let requestPaymentParams = {
            // 'CDSID': '405945',
            Odometer: vehicle.mileage, //ask if this is correct
            // 'Odometer': vehicle.mileage < 1000 ? vehicle.mileage * 1000 : vehicle.mileage,//ask if this is correct
            // 'Term': paymentData.loanMonths,//All all
            // 'DownPayment': downPayment,
            // 'Beacon': paymentData.creditRating,
            Purchase: parseFloat(vehicle.finalPrice),
            MSRP: vehicle.finalPrice,
            sxml: "3",
            ZipCode: pmdrs.config.dealerZipCode, //include it if not state, city and county
            // 'state': values.state, //include if not zipcode
            // 'city': values.city, //include if not zipcode
            // 'county': values.county,//include if not zipcode
            "vehicle.LienStatus": type == "cash" ? 0 : 1,
            // 'vehicle.dealerRebate': paymentData.totalIncentives || 0,
            // 'vehicle.manufacturerRebate': paymentData.totalIncentives || 0,
            CustRebates: paymentData.totalIncentives || 0,
            // 'vehicle.manufacturerRebate': 0,
            // 'vehicle.tradeInAmount': paymentData.tradeInData.tradeInEstimate,
            taxes: taxes ? 1 : 0,
        };
        Object.assign(requestParams, requestPaymentParams);

        if (type == "lease" || type == "finance") {
            let downPayment = parseFloat(paymentData.cashDown) + parseFloat(paymentData.tradeInData.tradeInEstimate);

            requestParams["Beacon"] = paymentData.creditRating;
            requestParams["Term"] = paymentData.loanMonths;
            requestParams["DownPayment"] = downPayment;
        }

        if (type == "lease") {
            /**
             * (Current list of supported miles are: 2,500, 4,000, 5,000, 7,500, 8,000, 10,000, 10,500, 12,000,
             * 13,500, 15,000, 16,000, 16,500, 18,000, 19,500, 20,000, 24,000, & 25,000)
             * use small numbers: 5 = 5,000 miles per year
             */
            requestParams.Miles = paymentData.mileageAllowance / 1000;
        } else {
            //finance
            requestParams["vehicle.tradeInAmount"] = paymentData.tradeInData.tradeInEstimate;
            // requestParams.DownPayment = paymentData.cashDown;
        }

        pmdrs.pmApi.getOfferlogixPayments(requestParams, sc, errorCallback);
    }

    /**
     * [getCSRIncentives description]
     * @param  {String} dealType        finance lease or cash
     * @param  {[type]} successCallback [description]
     * @param  {[type]} errorCallback   [description]
     * @return {[type]}                 [description]
     */
    getCSRIncentives(dealType, successCallback, errorCallback) {
        let pmdrs = this.pmdrs;

        let csrDealType = "";
        switch (dealType) {
            case "lease":
                csrDealType = "manufacturer_lease_special";
            default:
                csrDealType = "manufacturer_special_apr";
        }

        let requestParams = {
            vin: pmdrs.frontApp.config.vehicle.vin,
            postalCode: pmdrs.config.dealerZipCode,
            dealType: csrDealType,
        };

        pmdrs.pmApi.findVehicleGroups(requestParams, successCallback, errorCallback);
    }

    /**
     * [getCreditRanges description]
     * @param  {[type]} dealType lease or finance
     * @return {[type]}          [description]
     */
    getCreditRanges(dealType) {
        return this.apr.range_config[dealType];
    }
}
